module.exports = __webpack_public_path__ + "08_long_brown.976a37ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_long_brown.png
// module id = CY/G
// module chunks = 0